<div class="h-full overflow-hidden relative">
  <!-- Main content - shifts when panel opens -->
  <div class="h-full overflow-y-auto transition-[margin-right] duration-300"
       [style.margin-right]="sidePanelOpen ? '360px' : '0'">
<form [formGroup]="allSamplesForm">

    <!-- Top Action Bar -->
    <div class="flex items-center gap-2.5 pt-5 px-7">
      <button (click)="back()"
        class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">arrow_back</span> Back
      </button>
      <button (click)="openMergeWithDialog()"
        class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">merge_type</span> Merge With
      </button>
      <button (click)="openDeleteGroupDialog()"
        class="py-2 px-4 bg-[var(--notification-error)] text-white rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 hover:opacity-90 transition-all">
        <span class="material-icons text-[16px]">delete</span> Delete
      </button>

      <!-- Export Dropdown -->
      <div class="relative">
        <button (click)="showExportMenu = !showExportMenu; $event.stopPropagation()"
          class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
          <span class="material-icons text-[16px]">file_download</span> Export
        </button>
        <div *ngIf="showExportMenu"
          class="absolute top-[calc(100%+4px)] left-0 bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100] min-w-[120px]">
          <div (click)="exportSampleGroupAsExcel(); showExportMenu=false"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Excel</div>
          <div (click)="exportSampleGroupAsShapefile(); showExportMenu=false"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Shapefile</div>
        </div>
      </div>
    </div>

    <!-- Group Info -->
    <div class="flex items-center gap-3 px-7 py-4">
      <span class="material-icons text-[var(--primary-dark)] text-[20px] cursor-pointer" (click)="openEditGroupDialog()">edit</span>
      <span class="text-[14px] font-bold text-[var(--base-text-alt-dark)]">Group Name:</span>
      <span class="text-[14px] font-medium text-[var(--base-text-alt-dark)]">{{groupName || placeholder}}</span>
      <span class="text-[var(--app-border)] mx-1">|</span>
      <span class="text-[13px] font-bold text-[var(--base-text-alt-dark)]">Date Created:</span>
      <span class="text-[13px] text-[var(--base-text-alt-dark)]">{{groupInfo ? dayjs(groupInfo.dateCreated).format(dateStringFormatting) : placeholder}}</span>
      <span class="text-[var(--app-border)] mx-1">|</span>
      <span class="text-[13px] font-bold text-[var(--base-text-alt-dark)]">Created By:</span>
      <span class="text-[13px] text-[var(--base-text-alt-dark)]">{{groupInfo ? groupInfo.user.userName : placeholder}}</span>

      <div class="flex-1"></div>

      <!-- Pins sharing a position, from the map's overlap check -->
      <span *ngIf="showMap && overlapCount > 0"
        class="flex items-center gap-1 text-[11px] font-semibold px-2.5 py-1 rounded-full bg-[#FFF6D6] text-[#8A6D00]"
        title="Pins within 12 m of another pin in this group">
        <span class="material-icons text-[13px]">warning</span>{{overlapCount}} overlapping
      </span>
    </div>

    <div class="h-px bg-[var(--app-base)] mx-7"></div>

    <!-- Toolbar -->
    <div class="flex items-center gap-2.5 py-3.5 px-7 flex-wrap">
      <!-- Search -->
      <div class="relative">
        <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
        <input type="text" placeholder="Search..." (keyup)="searchSamples($event.target.value)"
          class="search-input py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)]">
      </div>

      <!-- Clear Filters -->
      <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
      </button>

      <!-- Pin Type Filter -->
      <div class="relative">
        <div (click)="showPinTypeMenu = !showPinTypeMenu; $event.stopPropagation()"
          class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
          <img *ngIf="pinType?.id" [src]="'../../assets/icons/' + pinIcons[pinType.id]" class="w-4 h-4" alt="">
          <span *ngIf="!pinType?.id" class="material-icons text-[16px]">filter_list</span>
          <span>{{pinType?.name || 'All Pin Types'}}</span>
          <span class="material-icons text-[16px]">expand_more</span>
        </div>
        <div *ngIf="showPinTypeMenu"
          class="absolute top-[calc(100%+4px)] left-0 min-w-[200px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
          <div *ngFor="let pt of pinTypesList" (click)="selectPinType(pt)"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)] flex items-center gap-2"
            [class.font-semibold]="pt === pinType">
            <img *ngIf="pt?.id" [src]="'../../assets/icons/' + pinIcons[pt.id]" class="w-4 h-4" alt="">
            <span *ngIf="!pt?.id" class="material-icons text-[16px]">filter_list</span>
            <span>{{pt.name}}</span>
          </div>
        </div>
      </div>

      <!-- Map toggle -->
      <button type="button" (click)="toggleMap()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">public</span> {{ showMap ? 'Hide Map' : 'Show Map' }}
      </button>

      <div class="flex-1"></div>

      <!-- Date Range -->
      <div class="flex gap-2.5">
        <app-custom-datepicker label="START DATE" [value]="filterStartDate" (valueChange)="filterStartDate=$event; filterDateRange()"></app-custom-datepicker>
        <app-custom-datepicker label="END DATE" [value]="filterEndDate" (valueChange)="filterEndDate=$event; filterDateRange()"></app-custom-datepicker>
      </div>
    </div>

    <!-- Map + Table -->
    <div class="flex gap-3 px-7" [ngStyle]="{'height': tableHeight}">

      <!-- Map: left half, hidden when the map is toggled off -->
      <div *ngIf="showMap" class="flex-none w-1/2 min-w-0">
        <app-sample-group-map
          [groupId]="groupId"
          [samples]="dataSource.data"
          [selectedPinId]="selectedPinId"
          (pinSelected)="onMapPinSelected($event)"
          (overlapsChanged)="overlapCount = $event">
        </app-sample-group-map>
      </div>

      <div class="flex-1 min-w-0 overflow-y-auto overflow-x-hidden">
      <table mat-table [dataSource]="dataSource.data" class="w-full border-collapse">

        <ng-container matColumnDef="table-checkboxes">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">
            <input type="checkbox" (change)="toggleAllSelection($event)" [checked]="isSampleitemSelected"
              class="w-4 h-4 accent-[var(--primary-dark)] cursor-pointer" (click)="$event.stopPropagation()">
          </th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">
            <input type="checkbox" (change)="onSampleSelectedChecked($event,element.id)" [checked]="selectedToMove.includes(element.id)"
              class="w-4 h-4 accent-[var(--primary-dark)] cursor-pointer" (click)="$event.stopPropagation()">
          </td>
        </ng-container>

        <ng-container matColumnDef="table-farm">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Farm</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.farm.name ? element.farm.name : placeholder}}</td>
        </ng-container>

        <ng-container matColumnDef="table-field">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Field</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.field.name ? element.field.name : placeholder}}</td>
        </ng-container>

        <ng-container matColumnDef="table-pinType">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Pin Type</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element.pinType.name ? element.pinType.name : placeholder}}</td>
        </ng-container>

        <ng-container matColumnDef="table-sample">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Sample</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.name ?? placeholder}}</td>
        </ng-container>

        <!-- This screen is ordered by bag number within each field, so the column has to be
             visible or the row order looks arbitrary to the user. -->
        <ng-container matColumnDef="table-bagNumber">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Bag Number</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.bagNumber ?? placeholder}}</td>
        </ng-container>

        <ng-container matColumnDef="table-dateCreated">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Date Created</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element.dateCreated ? dayjs(element.dateCreated).format(dateStringFormatting) : placeholder}}</td>
        </ng-container>

        <ng-container matColumnDef="table-createdBy">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Created By</th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.user?.userName ?? placeholder}}</td>
        </ng-container>

        <ng-container matColumnDef="table-actions">
          <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !bg-[var(--app-base)] !border-b !border-[var(--app-base)]"></th>
          <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !border-b !border-[var(--app-base)]">
            <span class="material-icons text-[18px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]" (click)="viewSampleInfo(element)">chevron_right</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" style="height: auto; min-height: unset"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="cursor-pointer transition-colors !h-auto"
          style="height: auto; min-height: unset"
          (click)="viewSampleInfo(row)"></tr>
      </table>

      <div *ngIf="isNoItemsFound" [ngStyle]="{'height': tableHeight}" class="flex items-center justify-center text-[var(--tertiary-text)] text-[13px]">
        Sorry! No items found within the selected filter range.
      </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="flex items-center py-3.5 px-7 gap-4 border-t border-[var(--app-base)]">
      <!-- Move To Button -->
      <button (click)="openMoveSampleDialogDialog()"
        class="py-2 px-4 bg-[var(--primary-dark)] text-white rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 hover:opacity-90 transition-all">
        <span class="material-icons text-[16px]">drive_file_move</span> Move To
      </button>

      <div class="flex-1"></div>

      <!-- Paginator -->
      <span class="text-[12px] text-[var(--tertiary-text)] font-medium">Items per page:</span>
      <div class="relative" #pageSizeDropdown>
        <div (click)="showPageSizeMenu = !showPageSizeMenu; $event.stopPropagation()"
          class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
          <span>{{pageSize}}</span>
          <span class="material-icons text-[16px]">expand_more</span>
        </div>
        <div *ngIf="showPageSizeMenu"
          class="absolute bottom-[calc(100%+4px)] left-0 min-w-[80px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
          <div *ngFor="let size of [5, 10, 25, 100]"
            (click)="pageSize = size; showPageSizeMenu = false; onPageSizeChange()"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
            [class.font-semibold]="size === pageSize">
            {{size}}
          </div>
        </div>
      </div>
      <span class="text-[13px] text-[var(--base-text-alt-dark)] font-medium">{{currentPage * pageSize + 1}} – {{min((currentPage + 1) * pageSize, totalElements)}} of {{totalElements}}</span>
      <div class="flex gap-1">
        <button (click)="goToPage(0)" [disabled]="currentPage === 0"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default transition-all">
          <span class="material-icons text-[16px]">first_page</span>
        </button>
        <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default transition-all">
          <span class="material-icons text-[16px]">chevron_left</span>
        </button>
        <button (click)="goToPage(currentPage + 1)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default transition-all">
          <span class="material-icons text-[16px]">chevron_right</span>
        </button>
        <button (click)="goToPage(lastPage)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default transition-all">
          <span class="material-icons text-[16px]">last_page</span>
        </button>
      </div>
    </div>

  </form>
  </div>

  <!-- Side Panel -->
  <div class="fixed right-0 top-[56px] bottom-0 w-[360px] bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.08)] z-[850] transition-transform duration-300 flex flex-col overflow-hidden"
       [class.translate-x-full]="!sidePanelOpen"
       [class.translate-x-0]="sidePanelOpen">
    <!-- Header -->
    <div class="border-t-[3px] border-t-[var(--primary-dark)]">
      <div class="flex items-center gap-2 py-4 px-5 border-b border-[var(--app-base)]">
        <span class="text-[14px] font-semibold flex-1 leading-none text-[var(--base-text-alt-dark)]">Edit Sample</span>
        <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
              (click)="closeSidePanel()">close</span>
      </div>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto p-5" *ngIf="editingSample">
      <!-- Sample Name -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Sample Name *</label>
        <input type="text" [(ngModel)]="editSampleName"
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
      </div>

      <!-- Bag Number -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Bag Number</label>
        <input type="text" [(ngModel)]="editSampleBagNumber" placeholder="Bag number" maxlength="30"
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
      </div>

      <!-- Soil fields -->
      <ng-container *ngIf="editingSample.pinType?.id === 4">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Sample Depth (CM)</label>
          <input type="text" inputmode="decimal" [(ngModel)]="editSampleDepth"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Rock %</label>
          <input type="text" inputmode="decimal" [(ngModel)]="editRockPercentage"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)]">
        </div>
      </ng-container>

      <!-- Soft Tissue fields -->
      <ng-container *ngIf="editingSample.pinType?.id === 3">
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Growth Stage</label>
          <div class="relative" *ngIf="growthStages.length > 0">
            <div (click)="showGrowthStageDropdown = !showGrowthStageDropdown; $event.stopPropagation()"
              class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
              <span>{{getGrowthStageName(editGrowthStageLinkId) || 'Select growth stage'}}</span>
              <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
            </div>
            <div *ngIf="showGrowthStageDropdown"
              class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
              <div (click)="editGrowthStageLinkId = null; showGrowthStageDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Select growth stage</div>
              <div *ngFor="let gs of growthStages" (click)="editGrowthStageLinkId = gs.id; showGrowthStageDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
                {{gs.name}} {{gs.cropDescription ? '(' + gs.cropDescription + ')' : ''}}
              </div>
            </div>
          </div>
          <span *ngIf="growthStages.length === 0" class="text-[12px] text-[var(--tertiary-text)]">No growth stages available</span>
        </div>
        <div class="mb-4">
          <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Plant Part</label>
          <div class="relative">
            <div (click)="showPlantPartDropdown = !showPlantPartDropdown; $event.stopPropagation()"
              class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
              <span>{{getPlantPartName(editPlantPartId) || 'Select plant part'}}</span>
              <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
            </div>
            <div *ngIf="showPlantPartDropdown"
              class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
              <div (click)="editPlantPartId = null; showPlantPartDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Select plant part</div>
              <div *ngFor="let pp of plantParts" (click)="editPlantPartId = pp.id; showPlantPartDropdown = false"
                class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
                {{pp.name}}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Note -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Note</label>
        <textarea [(ngModel)]="editSampleNote" placeholder="Add a note..."
          class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] resize-y min-h-[80px] placeholder:text-[var(--base-text-alt-dark)]"></textarea>
      </div>

      <!-- Group -->
      <div class="mb-4">
        <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Group *</label>
        <div class="relative">
          <div (click)="showEditGroupDropdown = !showEditGroupDropdown; $event.stopPropagation()"
            class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark)]">
            <span>{{editSelectedGroup?.name || 'Select a group'}}</span>
            <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
          </div>
          <div *ngIf="showEditGroupDropdown"
            class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[180px] overflow-y-auto">
            <div *ngFor="let g of groups" (click)="selectEditGroup(g)"
              class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
              {{g.name}}
            </div>
          </div>
        </div>
      </div>

      <!-- Mark Complete -->
      <label class="flex items-center gap-2 cursor-pointer">
        <input type="checkbox" [(ngModel)]="editIsCompleted" class="w-4 h-4 accent-[var(--primary-dark)]">
        <span class="text-[13px] font-medium text-[var(--base-text-alt-dark)]">Mark as Completed</span>
      </label>
    </div>

    <!-- Actions -->
    <div class="py-4 px-5 border-t border-[var(--app-base)] flex gap-2.5" *ngIf="editingSample">
      <button (click)="closeSidePanel()"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer flex items-center gap-1.5 bg-white text-[var(--base-text-alt-dark)] border-[1.5px] border-[var(--app-border)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">arrow_back</span> Back
      </button>
      <button (click)="deleteSample()"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--notification-error)] text-white hover:opacity-90">
        Delete
      </button>
      <div class="flex-1"></div>
      <button (click)="updateSample()" [disabled]="!editSampleName"
        class="py-2.5 px-[18px] rounded-lg text-[13px] font-semibold cursor-pointer border-none flex items-center gap-1.5 bg-[var(--primary-dark)] text-white hover:opacity-90 disabled:opacity-40 disabled:cursor-default">
        Update
      </button>
    </div>
  </div>
</div>
